import styled from 'styled-components';
import vector from '../../../../assets/equipment/vector.svg';
import vectorlight from '../../../../assets/equipment/vectorlight.svg';
import check from '../../../../assets/certificates/AddParameter/Modal/check.svg';
import cross from '../../../../assets/certificates/AddParameter/Modal/switch-cross.svg';
import trashIcon from '../../../../assets/production-flow/trash.svg';

export const FormFieldsScope = styled.div`
  button {
    transition: none !important;
  }

  input:not([type='checkbox']),
  select,
  textarea {
    outline: none !important;
    box-shadow: none !important;

    &:hover:not(:disabled):not([readonly]),
    &:focus,
    &:focus-visible,
    &:active {
      outline: none !important;
      box-shadow: none !important;
    }
  }

  input[data-field-error='true']:not([type='checkbox']),
  select[data-field-error='true'],
  textarea[data-field-error='true'] {
    border: 1.5px solid #f87171 !important;
    box-shadow: 0 0 3px #f87171 !important;
  }

  .financial-form-field[data-field-error='true'] {
    border: 1.5px solid #f87171 !important;
    box-shadow: 0 0 3px #f87171 !important;
  }

  .financial-form-field {
    transition: none !important;

    &:hover:not(:disabled),
    &:focus,
    &:focus-visible,
    &:active {
      border-color: #ebebeb !important;
      box-shadow: none !important;
      background-color: #ebebeb !important;
      outline: none !important;
    }
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 0;
`;

export const CardTitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #303030;
`;

export const FormGrid = styled.div<{ cols?: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.cols ?? 3}, 1fr);
  gap: 16px 24px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const FormSearchableSelectWrap = styled.div<{ $hasError?: boolean }>`
  input:not([type='checkbox']) {
    color: #696969;
    font-family: 'Inter', sans-serif;
    font-size: 13px;
    transition: none;
    outline: none;
    box-shadow: none;

    &:hover:not(:disabled),
    &:focus,
    &:focus-visible,
    &:active {
      border-color: transparent !important;
      box-shadow: none !important;
      background-color: #ebebeb !important;
      outline: none !important;
    }

    &::placeholder {
      color: #c4c4c4;
    }
  }

  ${({ $hasError }) =>
    $hasError &&
    `
    input:not([type='checkbox']) {
      border: 1.5px solid #f87171 !important;
      box-shadow: 0 0 3px #f87171 !important;
    }
  `}

  label {
    font-size: 13px;
    color: #303030;
    font-weight: bold;
    transition: none;
  }
`;

export const StyledFormGroup = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-size: 13px;
    color: #303030;
    margin-bottom: 6px;
    font-weight: bold;
    min-height: 20px;
    display: block;
  }

  input:not([type='checkbox']),
  select,
  textarea {
    padding: 6px 14px;
    border: 1px solid #ebebeb;
    border-radius: 100px;
    font-size: 13px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    min-height: 36px;
    background-color: #ebebeb;
    color: #696969;
    font-family: 'Inter', sans-serif;
    transition: none;

    &::placeholder {
      color: #c4c4c4;
    }

    &:hover:not(:disabled):not([readonly]),
    &:focus,
    &:focus-visible,
    &:active {
      border-color: #ebebeb;
      box-shadow: none;
      background-color: #ebebeb;
      outline: none;
    }

    &:disabled,
    &[readonly] {
      background-color: #c4c4c4;
      color: #696969;
      cursor: not-allowed;
      border-color: #c4c4c4;
    }
  }

  textarea {
    border-radius: 16px;
    min-height: 80px;
    resize: vertical;
    padding: 10px 14px;
  }

  select {
    background-image: url(${vector});
    background-size: 18px 9px;
    background-repeat: no-repeat;
    background-position: right 15px center;
    padding-right: 2.5rem;
    appearance: none;
    cursor: pointer;

    &:disabled {
      background-image: url(${vectorlight});
      background-size: 32px 16px;
    }
  }
`;

export const ReadOnlyValue = styled.div`
  padding: 6px 14px;
  border: 1px solid #ebebeb;
  border-radius: 100px;
  font-size: 13px;
  min-height: 36px;
  display: flex;
  align-items: center;
  background-color: #c4c4c4;
  color: #696969;
  box-sizing: border-box;
`;

export const ParcelasPanel = styled.div`
  margin-top: 16px;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 16px;
`;

export const ParcelasPanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

export const ParcelasTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #303030;
`;

export const UpdateInstallmentsButton = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  background: #fff;
  border: 1px solid #0090d3;
  color: #0090d3;
  border-radius: 100px;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  white-space: nowrap;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const InstallmentsHeader = styled.div`
  display: grid;
  grid-template-columns: 72px 1fr 1fr 1.2fr 40px;
  gap: 12px;
  margin-bottom: 8px;
  padding: 0 4px;

  span {
    font-size: 12px;
    font-weight: 700;
    color: #303030;
  }

  span:first-child {
    text-align: center;
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

export const InstallmentRow = styled.div`
  display: grid;
  grid-template-columns: 72px 1fr 1fr 1.2fr 40px;
  gap: 12px;
  align-items: end;
  margin-bottom: 12px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 12px;
  }
`;

export const InstallmentLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #303030;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const CommissionCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  input {
    flex: 1;
    min-width: 0;
  }
`;

export const ToggleSwitchContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 34px;
  cursor: pointer;
`;

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + .slider {
    background-color: #0090d3;
    border-color: #0090d3;
  }

  &:checked + .slider:before {
    background-image: url(${check});
    background-color: #fff;
    transform: translateX(13px);
  }

  &:disabled + .slider {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
  border: 2px solid #696969;

  &:before {
    display: block;
    position: relative;
    content: '';
    height: 24px;
    width: 24px;
    left: 4px;
    top: 2.8px;
    background-color: #696969;
    border-radius: 50%;
    transition: all 0.4s;
    background-image: url(${cross});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 11px 11px;
  }
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  color: #696969;

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`;

export const DeleteIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  padding: 0;

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }

  img {
    width: 16px;
    height: 18px;
    display: block;
  }
`;

export const DeleteTrashIcon = styled.img.attrs({ src: trashIcon, alt: 'Remover' })``;

export const CompetenceGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0;

  > label {
    font-size: 13px;
    color: #303030;
    margin-bottom: 6px;
    font-weight: bold;
    min-height: 20px;
    display: block;
  }
`;

export const CompetenceFieldsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  input:not([type='checkbox']) {
    padding: 6px 14px;
    border: 1px solid #ebebeb;
    border-radius: 100px;
    font-size: 13px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    min-height: 36px;
    background-color: #ebebeb;
    color: #696969;
    font-family: 'Inter', sans-serif;
    transition: none;

    &::placeholder {
      color: #c4c4c4;
    }

    &:hover:not(:disabled):not([readonly]),
    &:focus,
    &:focus-visible,
    &:active {
      border-color: #ebebeb;
      box-shadow: none;
      background-color: #ebebeb;
      outline: none;
    }

    &:disabled,
    &[readonly] {
      background-color: #c4c4c4;
      color: #696969;
      cursor: not-allowed;
      border-color: #c4c4c4;
    }
  }
`;

export const AddInstallmentButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin-top: 8px;
  padding: 10px 20px;
  background: #fff;
  border: 1px solid #0090d3;
  color: #0090d3;
  border-radius: 100px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

export const ItemCard = styled.div`
  border: 1px solid #ebebeb;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
`;

export const AddItemButton = styled(AddInstallmentButton)`
  margin-top: 0;
`;

export const AttachmentHeaderBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 100px;
  border: 1px solid #ebebeb;
  background-color: #ebebeb;
  padding: 0 14px 0 15px;
  width: 100%;
  min-height: 40px;
  box-sizing: border-box;
`;

export const AttachmentCount = styled.span`
  color: #0090d3;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1;
`;

export const AttachmentClipLabel = styled.label`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  color: #0090d3;
  margin: 0;
  padding: 0;
  line-height: 0;

  img {
    display: block;
    transform: translateY(4px);
  }

  input {
    display: none;
  }
`;

export const ErrorText = styled.span`
  color: #f87171;
  font-size: 12px;
`;

export const SectionErrorList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
`;

export const SectionErrorMessage = styled.p`
  color: #f87171;
  font-size: 12px;
  margin: 0;
`;


export const CancelButton = styled.button`
  background-color: #ffffff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 8px 16px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
`;

export const SaveButton = styled.button`
  background-color: #d1d5db;
  color: #9ca3af;
  border: none;
  padding: 8px 16px;
  border-radius: 100px;
  cursor: not-allowed;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;

  &:not(:disabled) {
    background-color: #0090d3;
    color: white;
    cursor: pointer;
  }
`;
